'use client'

import { useContext } from 'react'

import type { LeftBarButtonProps } from '@/components/LeftBarButton/LeftBarButton'
import { LeftBarButton } from '@/components/LeftBarButton/LeftBarButton'
import { Link } from '@/components/Link/Link'
import { Text } from '@/components/Text/Text'
import { ThemeContext } from '@/utils/themeContext'

import css from './ArticleButton.module.css'

interface ArticleButtonProps extends Omit<LeftBarButtonProps, 'children'> {
    title: string
    htmlPreview: string
    href: string
    link: string
}

export function ArticleButton({
    title,
    htmlPreview = '',
    href,
    link,
    ...rest
}: ArticleButtonProps) {
    const { theme } = useContext(ThemeContext)

    return (
        <LeftBarButton href={href} {...rest}>
            <div className={css.articleBtn}>
                <div className={css.heading}>
                    <Text
                        className={css.heading}
                        size="minor-base"
                        weight={theme === 'todoist' ? 'medium' : undefined}
                    >
                        {title}
                    </Text>
                    <div
                        // biome-ignore lint/security/noDangerouslySetInnerHtml: sanitized earlier (I hope)
                        dangerouslySetInnerHTML={{ __html: htmlPreview }}
                        className={css.preview}
                    />
                </div>

                <Link tag="span" icon="external" size="body-xs">
                    {link}
                </Link>
            </div>
        </LeftBarButton>
    )
}
